export const ROUTES = {
  LOGIN: "/login",
  EXCEPTION: "/exception",
  DASHBOARD: "/",
  INVESTIGATE: "/channel-investigate",
  MATCHINGRULE: "/matchingrule",
  AUDITLOG: "/auditlog",
  AIMATCH: "/aimatch",
  REPORTS: "/reports",
  TEMPLATES: "/templates",
};
